/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { MoonIcon, SunIcon } from '@radix-ui/react-icons';

import { styled, useCallback } from 'fierry/react';

import { useBoundPreference } from 'solis/preferences';

import useSystemAppearance from 'solis/theme/system';


const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 9999px;
  background: var(--gray-3);
  box-shadow: 0 0 0 1px var(--gray-a5);
  color: var(--gray-12);
  cursor: pointer;

  &:hover { background: var(--gray-5); }
  &:active { background: var(--gray-6); }
`;


export default () =>
{
  const [ appearance, setAppearance ] = useBoundPreference('appearance', useSystemAppearance());

  const onClick = useCallback(() =>
  {
    setAppearance(appearance === 'light' ? 'dark' : 'light');
  });

  const label = appearance === 'light' ? 'Switch to dark mode' : 'Switch to light mode';

  return (
    <Button type = 'button' onClick = {onClick} aria-label = {label}>
      {appearance === 'light' ? <SunIcon /> : <MoonIcon />}
    </Button>
  );
};
